import { render, staticRenderFns } from "./BlockListView.vue?vue&type=template&id=b89b286e&"
import script from "./BlockListView.vue?vue&type=script&lang=js&"
export * from "./BlockListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports